import { PDADataService } from '../../../services/base/PDADataService';
import { hasEmbeddedDataImage, withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { ProjectDocFolder } from '../models/ProjectDocFolder';
import { ProjectDocFolderAttachment } from '../models/ProjectDocFolderAttachment';

export class PaperSigningService extends PDADataService {
    protected prefixUrl: string = `PaperSigning`;

    generate(projectDocId: number) {
        return this.api.post<number>(`${this.prefixUrl}/Generate?projectDocId=${projectDocId}`, null);
    }

    getTree(projectDocId: number) {
        return this.api.get<ProjectDocFolder[]>(`${this.prefixUrl}/GetTree?projectDocId=${projectDocId}`);
    }

    uploadSigned(slotFolderId: number, file: File) {
        const data = new FormData();
        data.append('file', file, file.name);
        return this.api.post(`${this.prefixUrl}/UploadSigned?slotFolderId=${slotFolderId}`, data, withUploadRejectionDetection({
            headers: { 'Content-Type': 'multipart/form-data' }
        }));
    }

    startApproval(projectDocId: number) {
        return this.api.post<number>(`${this.prefixUrl}/StartApproval?projectDocId=${projectDocId}`, null);
    }

    cancelApproval(projectDocId: number, comment?: string) {
        if (hasEmbeddedDataImage(comment)) {
            return this.api.post(`${this.prefixUrl}/CancelApproval?projectDocId=${projectDocId}`, comment ?? null, withUploadRejectionDetection());
        }
        return this.api.post(`${this.prefixUrl}/CancelApproval?projectDocId=${projectDocId}`, comment ?? null);
    }

    getSlotAttachments(slotFolderId: number, typeId: number) {
        return this.api.get<ProjectDocFolderAttachment[]>(
            `${this.prefixUrl}/GetSlotAttachments?slotFolderId=${slotFolderId}&typeId=${typeId}`
        );
    }

    getPaperSigningStatus(projectDocId: number) {
        return this.api.get<{ StatusId: number | null }>(
            `${this.prefixUrl}/GetPaperSigningStatus?projectDocId=${projectDocId}`
        );
    }
}
